<template>
  <app-page-container title="مدیریت کاربران">
    <template v-slot:header>
      <v-col cols="4" class="mr-n11">
        <v-text-field outlined rounded placeholder="جستجو..." append-icon="mdi-magnify" dense v-model="searchTitle"
          class="mt-3"></v-text-field>
      </v-col>
      <v-col cols="1" class="mr-n3">
        <v-btn class="mx-2 mt-3" fab dark small @click="showSearchModal()" color="darkColor" elevation="0">
          <v-icon dark>mdi-filter mdi-18px</v-icon>
        </v-btn>
      </v-col>
      <v-col cols="1" class="mr-n6 mt-6" v-if="isSearch">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon light v-bind="attrs" v-on="on" @click="removeFilters()">
              mdi-filter-remove mdi-18px
            </v-icon>
          </template>
          <span>حذف فیلتر ها</span>
        </v-tooltip>
      </v-col>
      <v-spacer></v-spacer>
      <v-col cols="2" class="text-left">
        <v-btn rounded color="darkColor" dark @click="goToAddPage()" class="mt-3 normal-letter-spacing ml-3">
          <v-icon class="ml-1">mdi-plus mdi-18px</v-icon>
          افزودن کاربر
        </v-btn>
      </v-col>
    </template>
    <template v-slot:body>
      <v-row no-gutters class="background-main">
        <v-col cols="12">
          <v-card elevation="0" class="card-width body-card pa-0">
            <v-card-text class="pa-0">
              <template>
                <v-data-table :headers="userManagmentInformationTableHeaders" :items="userFilteredList"
                  :page.sync="page" :items-per-page="userFilteredList.length" height="68vh" fixed-header
                  :hide-default-footer="true" multi-sort class="elevation-0">
                  <template v-slot:[`item.status`]="{ item }">
                    <v-icon color="#3BCA79" v-if="item.status === true">
                      mdi-check-circle mdi-18px
                    </v-icon>
                    <span class="mr-2 table-status-text" v-if="item.status === true">آنلاین</span>
                    <v-icon color="#F56060" v-if="item.status === false">
                      mdi-close-circle mdi-18px
                    </v-icon>
                    <span class="mr-2 table-status-text" v-if="item.status === false">آفلاین</span>
                  </template>
                  <template v-slot:[`item.enableDisable`]="{ item }">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-switch @change="setActionType('enableDisable', item, item.enableDisable)"
                          v-model="item.enableDisable" flat inset dense class="mt-0 mr-16" color="#00CA2C" hide-details
                          v-bind="attrs" v-on="on"></v-switch>
                      </template>
                      <span>فعال/غیرفعال</span>
                    </v-tooltip>
                  </template>
                  <template v-slot:[`item.actions`]="{ item }">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon class="mt-1 mx-2" color="iconColor" style="cursor: pointer"
                          @click="setActionType('edit', item, '')" v-bind="attrs" v-on="on">
                          mdi-pencil
                        </v-icon>
                      </template>
                      <span>ویرایش</span>
                    </v-tooltip>
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon class="mt-1 mx-2" color="iconColor" style="cursor: pointer"
                          @click="setActionType('setUserPassword', item, '')" v-bind="attrs" v-on="on">
                          mdi-key
                        </v-icon>
                      </template>
                      <span>تعیین کلمه عبور</span>
                    </v-tooltip>
                    <v-menu rounded="lg">
                      <template v-slot:activator="{ on: menu, attrs }">
                        <v-tooltip top>
                          <template v-slot:activator="{ on: tooltip }">
                            <v-icon class="mt-1 mx-2" color="iconColor" style="cursor: pointer" v-bind="attrs"
                              v-on="{ ...tooltip, ...menu }">
                              mdi-more
                            </v-icon>
                          </template>
                          <span>بیشتر</span>
                        </v-tooltip>
                      </template>
                      <v-list>
                        <v-list-item dense v-for="actionItems in actionList" :key="actionItems.id"
                          @click="setActionType(actionItems.type, item, '')">
                          <v-list-item-icon>
                            <v-icon color="iconColor">{{ actionItems.icon }}</v-icon>
                          </v-list-item-icon>
                          <v-list-item-content>
                            <v-list-item-title>{{ actionItems.title }}</v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </template>
                  <template v-slot:no-data>
                    <span>اطلاعاتی جهت نمایش وجود ندارد</span>
                  </template>
                </v-data-table>
              </template>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" class="pa-0">
          <pagination-component ref="pagination">
            <div slot="action">
              <v-card elevation="0">
                <v-pagination class="mt-8" circle color="lightColor" v-model="page" :length="totalPages"
                  :total-visible="pageSize" :value="totalPages" prev-icon="mdi-chevron-left"
                  next-icon="mdi-chevron-right" @next="next()" @previous="previous()" @input="input()"></v-pagination>
              </v-card>
            </div>
          </pagination-component>
        </v-col>
      </v-row>
    </template>
    <template v-slot:append>
      <section>
        <confirm-dialog ref="confirm">
          <v-row slot="action" no-gutters>
            <v-spacer></v-spacer>
            <v-btn color="darkColor" small ref="yes" rounded class="normal-letter-spacing px-12 py-4 ml-2"
              style="color: white" @click="confirmDialogConfirmFunction()" :disabled="disabelConfirm">
              بله
            </v-btn>
            <v-btn small rounded text ref="no" class="normal-letter-spacing px-12 confirm-cancel-btn"
              @click="confirmDialogCancelFunction()">
              خیر
            </v-btn>
          </v-row>
        </confirm-dialog>
        <!--search ***********************************************-->
        <v-dialog width="450" v-model="searchModal">
          <v-card>
            <v-row no-gutters>
              <v-col cols="12" class="modal-header py-5">
                <v-row no-gutters>
                  <v-spacer></v-spacer>
                  <v-icon color="darkColor">mdi-magnify</v-icon>
                  <span class="modal-title-text mr-2">جستجو</span>
                  <v-spacer></v-spacer>
                </v-row>
              </v-col>
            </v-row>
            <v-card-text class="mt-12">
              <v-row>
                <v-col cols="12">
                  <v-text-field hide-details type="text" v-model="searchFields.fullName" dense clearable
                    clear-icon="mdi-close-circle-outline" outlined v-on:keyup.enter="search()"
                    label="نام و نام خانوادگی" class="input-label" prepend-inner-icon="mdi-account mdi-18px"
                    tabindex="1" :autofocus="true"></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field hide-details type="text" v-model="searchFields.userName" dense clearable
                    clear-icon="mdi-close-circle-outline" outlined v-on:keyup.enter="search()" label="نام کاربری"
                    class="input-label" prepend-inner-icon="mdi-account mdi-18px" tabindex="2"></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field hide-details type="text" v-model="searchFields.personnelNumber" dense clearable
                    clear-icon="mdi-close-circle-outline" outlined v-on:keyup.enter="search()" label="شماره پرسنلی"
                    class="input-label" prepend-inner-icon="mdi-account mdi-18px" tabindex="2"></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field hide-details type="text" v-model="searchFields.phoneNumber" dense clearable
                    clear-icon="mdi-close-circle-outline" outlined v-on:keyup.enter="search()" label="شماره همراه"
                    class="input-label" prepend-inner-icon="mdi-phone mdi-flip-h mdi-18px" tabindex="3"></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field hide-details type="text" v-model="searchFields.nationalCode" dense clearable
                    clear-icon="mdi-close-circle-outline" outlined v-on:keyup.enter="search()" label="کد ملی"
                    class="input-label" prepend-inner-icon="mdi-card-account-details mdi-18px"
                    tabindex="4"></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-autocomplete hide-details :items="allRoles" no-data-text="اطلاعاتی وجود ندارد" tabindex="5" dense
                    outlined multiple clearable clear-icon="mdi-close-circle-outline" item-text="persianTitle"
                    item-value="id" label="نقش" v-model="searchFields.roleId" autocomplete="off"
                    prepend-inner-icon="mdi-account-cog mdi-18px" style="font-size: 11px !important"></v-autocomplete>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions class="mt-2">
              <v-spacer></v-spacer>
              <v-btn color="darkColor" @click="search()" dark rounded tabindex="6" class="normal-letter-spacing px-12">
                جستجو
              </v-btn>
              <v-btn rounded color="darkColor" outlined tabindex="7" @click="cancelSearch()"
                class="normal-letter-spacing px-10">
                انصراف
              </v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!--change password-->
        <v-dialog width="500" v-model="changeUserPasswordModal" persistent>
          <v-card>
            <v-row no-gutters>
              <v-col cols="12" class="modal-header py-5">
                <v-row no-gutters>
                  <v-spacer></v-spacer>
                  <v-icon color="darkColor">mdi-pencil</v-icon>
                  <span class="modal-title-text mr-2">تعیین کلمه عبور</span>
                  <v-spacer></v-spacer>
                </v-row>
              </v-col>
            </v-row>
            <v-card-text>
              <v-row justify="center" class="mt-7">
                <v-col cols="10">
                  <v-text-field outlined label="کلمه عبور" v-model="setUserPassword" dense autocomplete="off"
                    prepend-inner-icon="mdi-key mdi-18px" :type="setUserPasswordClass"
                    :append-icon="setUserPasswordIcon" @click:append="setPasswordEyeClick('password')"
                    :hint="passwordHint" v-on:keyup.enter="showConfirmDialogFunction()"
                    @keydown.esc="cancelSetUserPasword()"></v-text-field>
                </v-col>
                <v-col cols="10">
                  <v-text-field outlined dense label="تکرار کلمه عبور" autocomplete="off"
                    :type="setUserRepeatPasswordClass" :append-icon="setUserRepeatPasswordIcon"
                    @click:append="setPasswordEyeClick('repeatPassword')" prepend-inner-icon="mdi-key mdi-18px"
                    v-model="setUserPasswordRepeat" v-on:keyup.enter="showConfirmDialogFunction()"
                    @keydown.esc="cancelSetUserPasword()"></v-text-field>
                </v-col>
                <v-col cols="10" class="mt-n10">
                  <v-checkbox v-model="setUserPasswordChangePassNext" label="تغییر کلمه عبور در ورود بعدی"></v-checkbox>
                </v-col>
              </v-row>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-col cols="5">
                <v-btn block color="#0D296E" dark rounded @click="showConfirmDialogFunction()">
                  ثبت
                </v-btn>
              </v-col>
              <v-col cols="5">
                <v-btn block outlined rounded color="#0D296E" @click="cancelSetUserPasword()">
                  انصراف
                </v-btn>
              </v-col>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!--roles *************************************************************************-->
        <v-dialog v-model="roleModal" persistent width="760">
          <v-card>
            <v-row no-gutters>
              <v-col cols="12" class="modal-header py-5">
                <v-row no-gutters>
                  <v-spacer></v-spacer>
                  <v-icon color="darkColor">mdi-pencil</v-icon>
                  <span class="modal-title-text mr-2">ویرایش نقش ها</span>
                  <v-spacer></v-spacer>
                </v-row>
              </v-col>
            </v-row>
            <v-card-text>
              <v-row class="mt-8">
                <span class="dialog-part-divider-text">نقش ها</span>
                <v-divider class="mt-2 mr-3"></v-divider>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-card elevation="0" height="26vh" class="inside-cards">
                    <v-card-text>
                      <v-chip class="mr-3 chip-text mt-2" label v-for="item in allUserRoles" :key="item.id">
                        {{ item.persianTitle }}
                        <v-icon right @click="addRoleToUserRoles(item)" color="darkColor">
                          mdi-plus
                        </v-icon>
                      </v-chip>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
              <v-row>
                <span class="dialog-part-divider-text">نقش های انتخابی</span>
                <v-divider class="mt-2 mr-3"></v-divider>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-card elevation="0" height="26vh" class="inside-cards">
                    <v-card-text>
                      <v-chip class="mr-3 mt-2" label v-for="item in allUserSelectedRoles" :key="item.id"
                        color="darkColor" dark>
                        {{ item.persianTitle }}
                        <v-icon right @click="removeRoleFromUserRoles(item)">mdi-close</v-icon>
                      </v-chip>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions class="mt-2">
              <v-spacer></v-spacer>
              <v-btn color="darkColor" @click="showConfirmDialogFunction()" dark rounded
                class="normal-letter-spacing px-12">
                ثبت
              </v-btn>
              <v-btn rounded color="darkColor" outlined @click="cancleEditUserRole()"
                class="normal-letter-spacing px-10">
                انصراف
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!--other Organization ***************************************************************************-->
        <v-dialog v-model="otherOrganizationModal" persistent width="760">
          <v-card>
            <v-row no-gutters>
              <v-col cols="12" class="modal-header py-5">
                <v-row no-gutters>
                  <v-spacer></v-spacer>
                  <v-icon color="darkColor">mdi-pencil</v-icon>
                  <span class="modal-title-text mr-2">ویرایش سازمان همکار</span>
                  <v-spacer></v-spacer>
                </v-row>
              </v-col>
            </v-row>
            <v-card-text>
              <v-row class="mt-8">
                <span class="dialog-part-divider-text">سازمان های همکار</span>
                <v-divider class="mt-2 mr-3"></v-divider>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-card elevation="0" height="26vh" class="inside-cards">
                    <v-card-text>
                      <v-chip class="mr-3 chip-text mt-2" label v-for="item in allUserOtherOrganizations"
                        :key="item.id">
                        {{ item.title }}
                        <v-icon right @click="addOtherOrganizationToUserOtherOrganizations(item)" color="darkColor">
                          mdi-plus
                        </v-icon>
                      </v-chip>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
              <v-row>
                <span class="dialog-part-divider-text">سازمان های همکار انتخابی</span>
                <v-divider class="mt-2 mr-3"></v-divider>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-card elevation="0" height="26vh" class="inside-cards">
                    <v-card-text>
                      <v-chip class="mr-3 mt-2" label v-for="item in allUserSelectedOtherOrganizations" :key="item.id"
                        color="darkColor" dark>
                        {{ item.title }}
                        <v-icon right @click="removeOtherOrganizationFromUserOtherOrganizations(item)">
                          mdi-close
                        </v-icon>
                      </v-chip>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions class="mt-2">
              <v-spacer></v-spacer>
              <v-btn color="darkColor" @click="showConfirmDialogFunction()" dark rounded
                class="normal-letter-spacing px-12">
                ثبت
              </v-btn>
              <v-btn rounded color="darkColor" outlined @click="cancleEditUserOtherOrganization()"
                class="normal-letter-spacing px-10">
                انصراف
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!--permisions ***************************************************************************-->
        <v-dialog v-model="permissionModal" persistent width="760">
          <v-card>
            <v-row no-gutters>
              <v-col cols="12" class="modal-header py-5">
                <v-row no-gutters>
                  <v-spacer></v-spacer>
                  <v-icon color="darkColor">mdi-pencil</v-icon>
                  <span class="modal-title-text mr-2">ویرایش سطح دسترسی</span>
                  <v-spacer></v-spacer>
                </v-row>
              </v-col>
            </v-row>
            <v-card-text>
              <v-row class="mt-8">
                <span class="dialog-part-divider-text">سطح دسترسی ها</span>
                <v-divider class="mt-2 mr-3"></v-divider>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-card elevation="0" height="26vh" class="inside-cards">
                    <v-card-text>
                      <v-chip class="mr-3 chip-text mt-2" label v-for="item in allUserPermissions" :key="item.id">
                        {{ item.title }}
                        <v-icon right @click="addPermssionToUserPermissions(item)" color="darkColor">
                          mdi-plus
                        </v-icon>
                      </v-chip>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
              <v-row>
                <span class="dialog-part-divider-text">سطح دسترسی های انتخابی</span>
                <v-divider class="mt-2 mr-3"></v-divider>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-card elevation="0" height="26vh" class="inside-cards">
                    <v-card-text>
                      <v-chip class="mr-3 mt-2" label v-for="item in allUserSelectedPermissions" :key="item.id"
                        color="darkColor" dark>
                        {{ item.title }}
                        <v-icon right @click="removePermissionFromUserPermissions(item)">
                          mdi-close
                        </v-icon>
                      </v-chip>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions class="mt-2">
              <v-spacer></v-spacer>
              <v-btn color="darkColor" @click="showConfirmDialogFunction()" dark rounded
                class="normal-letter-spacing px-12">
                ثبت
              </v-btn>
              <v-btn rounded color="darkColor" outlined @click="cancleEditUserPermision()"
                class="normal-letter-spacing px-10">
                انصراف
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!--cities ***************************************************************************-->
        <v-dialog v-model="cityModal" persistent width="760">
          <v-card>
            <v-row no-gutters>
              <v-col cols="12" class="modal-header py-5">
                <v-row no-gutters>
                  <v-spacer></v-spacer>
                  <v-icon color="darkColor">mdi-pencil</v-icon>
                  <span class="modal-title-text mr-2">ویرایش شهرستان ها</span>
                  <v-spacer></v-spacer>
                </v-row>
              </v-col>
            </v-row>
            <v-card-text>
              <v-row class="mt-8">
                <span class="dialog-part-divider-text">شهرستان ها</span>
                <v-divider class="mt-2 mr-3"></v-divider>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-card elevation="0" height="26vh" class="inside-cards">
                    <v-card-text>
                      <v-chip class="mr-3 chip-text mt-2" label v-for="item in allUserCitys" :key="item.id">
                        {{ item.title }}
                        <v-icon right @click="addCityToUserCitys(item)" color="darkColor">
                          mdi-plus
                        </v-icon>
                      </v-chip>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
              <v-row>
                <span class="dialog-part-divider-text">شهرستان های انتخابی</span>
                <v-divider class="mt-2 mr-3"></v-divider>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-card elevation="0" height="26vh" class="inside-cards">
                    <v-card-text>
                      <v-chip class="mr-3 mt-2" label v-for="item in allUserSelectedCitys" :key="item.id"
                        color="darkColor" dark>
                        {{ item.title }}
                        <v-icon right @click="removeCityFromUserCitys(item)">mdi-close</v-icon>
                      </v-chip>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions class="mt-2">
              <v-spacer></v-spacer>
              <v-btn color="darkColor" @click="showConfirmDialogFunction()" dark rounded
                class="normal-letter-spacing px-12">
                ثبت
              </v-btn>
              <v-btn rounded color="darkColor" outlined @click="cancleEditUserCity()"
                class="normal-letter-spacing px-10">
                انصراف
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!--hospital ***************************************************************************-->
        <v-dialog v-model="hospitalModal" persistent width="820">
          <v-card>
            <v-row no-gutters>
              <v-col cols="12" class="modal-header py-5">
                <v-row no-gutters>
                  <v-spacer></v-spacer>
                  <v-icon color="darkColor">mdi-pencil</v-icon>
                  <span class="modal-title-text mr-2">ویرایش بیمارستان ها</span>
                  <v-spacer></v-spacer>
                </v-row>
              </v-col>
            </v-row>
            <v-card-text>
              <v-row class="mt-8">
                <span class="dialog-part-divider-text">بیمارستان ها</span>
                <v-divider class="mt-2 mr-3"></v-divider>
              </v-row>
              <v-row>
                <v-col cols="5">
                  <v-text-field outlined rounded placeholder="جستجو..." append-icon="mdi-magnify" dense
                    v-model="editHopitalSearchText"></v-text-field>
                </v-col>
                <v-col cols="2">
                  <v-btn @click="addAllHospitals()" rounded block color="lightColor" dark class="normal-letter-spacing">
                    افزودن همه لیست
                  </v-btn>
                </v-col>
              </v-row>
              <v-row class="mt-n7">
                <v-col cols="12">
                  <v-card elevation="0" height="23vh" class="inside-cards">
                    <v-card-text>
                      <v-chip class="mr-3 chip-text mt-2" label v-for="item in allUserFilterdHospitals" :key="item.id">
                        {{ item.title }}
                        <v-icon right @click="addHospitalToUserHospitals(item)" color="darkColor">
                          mdi-plus
                        </v-icon>
                      </v-chip>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
              <v-row>
                <span class="dialog-part-divider-text">بیمارستان های انتخابی</span>
                <v-divider class="mt-2 mr-3"></v-divider>
              </v-row>
              <v-row>
                <v-col cols="5">
                  <v-text-field outlined rounded placeholder="جستجو..." append-icon="mdi-magnify" dense
                    v-model="editSelectedHopitalSearchText"></v-text-field>
                </v-col>
                <v-col cols="2">
                  <v-btn @click="removeAllHospitals()" rounded block color="lightColor" dark
                    class="normal-letter-spacing">
                    حذف همه لیست
                  </v-btn>
                </v-col>
              </v-row>
              <v-row class="mt-n7">
                <v-col cols="12">
                  <v-card elevation="0" height="23vh" class="inside-cards">
                    <v-card-text>
                      <v-chip class="mr-3 mt-2" label v-for="item in allUserSelectedFilterdHospitals" :key="item.id"
                        color="darkColor" dark>
                        {{ item.title }}
                        <v-icon right @click="removeHospitalFromUserHospitals(item)">
                          mdi-close
                        </v-icon>
                      </v-chip>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions class="mt-2">
              <v-spacer></v-spacer>
              <v-btn color="darkColor" @click="showConfirmDialogFunction()" dark rounded
                class="normal-letter-spacing px-12">
                ثبت
              </v-btn>
              <v-btn rounded color="darkColor" outlined @click="cancleEditUserHospital()"
                class="normal-letter-spacing px-10">
                انصراف
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!-- station -->
        <v-dialog v-model="isEditingStationModaOpen" width="820">
          <edit-user-station-modal-content v-if="isEditingStationModaOpen" :user-id="userId"
            @closeModal="closeEditStationModal" />
        </v-dialog>
      </section>
      <section>
        <alert-component ref="snackRef" :snakTimeOut="snakTimeOut" :snackColor="snackColor" :snackText="snackText"
          :snakIcon="snakIcon"></alert-component>
      </section>
    </template>
  </app-page-container>
</template>
<script>
import PaginationComponent from '@/components/PaginationComponent.vue';
import confirmDialog from '@/components/ConfirmDialog.vue';
import AlertComponent from '@/components/AlertComponent.vue';
import AppPageContainer from '@/components/app/PageContainer.vue';
import snackBar from '@/Mixins/snackBar.js';
import UserMixin from '@/Mixins/BaseInformation/UserMixin.js';
import ShearedMixin from '@/Mixins/Shared.js';
import ShearedHelper from '@/Helpers/Shared.js';
import pagination from '@/Mixins/Pagination';
import UserHelper from '@/Helpers/BaseInformation/UserHelper.js';
import EditUserStationModalContent from '@/components/BaseInformation/user/editStation.modal.vue';
import PermissionMixin from '@/Mixins/BaseInformation/PermissionMixin.js';
import RoleMixin from '@/Mixins/BaseInformation/RoleMixin.js';
import CityMixin from '@/Mixins/BaseInformation/CityMixin.js';
import HospitalMixin from '@/Mixins/BaseInformation/HospitalMixin.js';
import OtherOrganizationMixin from '@/Mixins/BaseInformation/OtherOrganizationMixin.js';

export default {
  name: 'UserManagment',
  title: 'کاربران',
  inject: ['load', 'tableImg', 'tableTitleImage'],
  components: {
    PaginationComponent,
    confirmDialog,
    AlertComponent,
    AppPageContainer,
    EditUserStationModalContent,
  },
  mixins: [
    UserMixin,
    pagination,
    UserHelper,
    ShearedMixin,
    PermissionMixin,
    snackBar,
    RoleMixin,
    CityMixin,
    HospitalMixin,
    ShearedHelper,
    OtherOrganizationMixin,
  ],
  created() {
    this.$root.$refs.UserManagment = this;
  },
  mounted() {
    this.mounteLoding();
  },
  data() {
    return {
      showAddEditModal: false,
    };
  },
  methods: {
    mounte: function () {
      this.initialFilter();
      // this.$refs.pagination.newPageSize = 10;
      // this.$refs.pagination.pageSize = 10;
      this.getListOfUsersWithPagination();
    },
    previous: function () {
      this.getListOfUsersWithPagination();
      this.$refs.pagination.page = this.page;
    },
    next: function () {
      this.getListOfUsersWithPagination();
      this.$refs.pagination.page = this.page;
    },
    input: function () {
      this.getListOfUsersWithPagination();
      this.$refs.pagination.page = this.page;
    },
  },
  computed: {
    userFilteredList() {
      return this.userPaginationList.filter((u) => {
        return u.fullName.toLowerCase().includes(this.searchTitle.toLowerCase());
      });
    },
  },
};
</script>
<style scoped>
.table-card {
  border-top-left-radius: 0px !important;
  border-top-right-radius: 0px !important;
  border-bottom-right-radius: 10px !important;
  border-bottom-left-radius: 10px !important;
  border-left: 2px solid #0f7af4 !important;
  border-right: 2px solid #0f7af4 !important;
  border-bottom: 2px solid #0f7af4 !important;
  border-top: none !important;
}

.header-title-content {
  color: white !important;
  font-size: 14px;
}

.header-title {
  margin-top: 2vh !important;
}

.modal-icon {
  margin-top: -7vh !important;
  margin-right: -1vh !important;
}

.table-status-text {
  font-size: 12px;
  margin-top: 2px !important;
}

.v-input--switch.v-input--dense.v-input--switch--inset .v-input--switch__track {
  height: 16.5px !important;
  width: 38px !important;
}

.v-input--switch.v-input--dense .v-input--switch__thumb {
  height: 12px !important;
  width: 12px !important;
}

.modal-header {
  border-bottom: 2px solid var(--modal-border-color);
  border-bottom-right-radius: 12px !important;
  border-bottom-left-radius: 12px !important;
}

.confirm-cancel-btn {
  border: solid 1px var(--dark-color);
  padding-top: 13px;
  padding-bottom: 15px;
  color: var(--dark-color);
}

.modal-title-text {
  color: var(--dark-color);
  font-weight: 500;
  font-size: 16px;
}

.inside-cards {
  border: 1px solid var(--dark-color) !important;
  overflow-y: auto !important;
}

.dialog-part-divider-text {
  color: #212121;
  font-size: 14px;
  font-weight: 600;
}

.chip-text {
  color: var(--dark-color) !important;
}

>>>.password.v-text-field__slot {
  font-family: 'password' !important;
}

.body-card {
  overflow-y: auto !important;
}

@media only screen and (min-width: 1280px) {
  .table-content {
    margin-top: 1vh !important;
  }

  .card-width {
    width: 99% !important;
    margin-right: 2vh !important;
  }
}

@media only screen and (min-width: 1366px) {
  .table-content {
    margin-top: 1vh !important;
  }

  .card-width {
    width: 98.5% !important;
    margin-right: 2vh !important;
  }
}

@media only screen and (min-width: 1536px) {
  .table-content {
    margin-top: 1vh !important;
  }

  .card-width {
    width: 99% !important;
    margin-right: 1vh !important;
  }
}
</style>
